export const GOOGLE_GEOCODE_API_KEY = 'AIzaSyDqIFVc2UdUftf7fpzb3Ejj_p2zSPcrnlI';
